import React from 'react'
import { Menu } from 'semantic-ui-react'

const RequestMenu = (props) => {
    const { items, active } = props
    return (
        <Menu pointing>
            {items.map((item, index) => {
                const { name, onClick } = item
                return (
                    <Menu.Item
                        key={index}
                        name={name}
                        active={active===index?true:false}
                        onClick={() => onClick(index)}
                    />
                )
            })}
        </Menu>
    )
}

export default RequestMenu